__turbopack_context__.v({
  "contentStrip": "isvv4W_contentStrip",
  "fullBleed": "isvv4W_fullBleed",
});
